import { ThemeConfig } from "antd";
import "./style-variables.scss";
// Test gitflow

export const themePrimary: ThemeConfig = {
  token: {
    colorPrimary: "#4f86bd",
    fontSize: 16,
    fontSizeHeading1: 45,
    fontSizeHeading2: 24,
  },
  components: {
    Button: {
      paddingInline: "25px",
      paddingBlock: "18px",
    },
    Input: {
      borderRadius: 4,
      colorTextPlaceholder: "var(--grey-text-placeholder)",
      colorBorder: "var(--grey-input-border)",
      fontSize: 14,
    },
    Select: {
      borderRadius: 4,
      colorTextPlaceholder: "var(--grey-text-placeholder)",
      colorBorder: "var(--grey-input-border)",
      fontSize: 14,
    },
    Card: {
      borderRadiusLG: 8,
      colorBgContainer: "#fff",
      boxShadow: "var(--shadow-card)", // TO FIX
      headerFontSize: 24,
      fontWeightStrong: 800,
      colorTextHeading: "var(--text-black)",
    },

    DatePicker: {
      borderRadius: 4,
      colorTextPlaceholder: "var(--grey-text-placeholder)",
    },

    Menu: {
      itemColor: "#fff",
      itemSelectedColor: "#fff",
      itemSelectedBg: "#396598",
      colorBgContainer: "#4F86BD",
      fontSize: 14,
      itemBorderRadius: 0,
      itemHoverColor: "#fff",
      itemMarginInline: 0,
    },
    Form: { labelColor: "#7E858D" },

    // NOTE: Doesn't work for some components
    Progress: {},
    Table: {},
  },
};

/* Note:

- Not possible to use custom variables.
- The native antd variables are limited to specific antd components (not all) 
  ex: borderRadius = works only on Cards, Buttons and a few other components. So if i want a global border-radius (and backgroundColor) for Forms, i'll have to wrap forms items into Cards components.

*/
